import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import VodafoneLoader from '../../assets/vodafone-loader.json';
import styles from './Loader.module.css';

export const Loader = () => {
  const element = useRef(null);
  const lottieInstance = useRef();

  useEffect(() => {

    const params = {
      loop: true,
      autoplay: true,
      animationData: VodafoneLoader,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    if (element.current) {
      lottieInstance.current = lottie.loadAnimation({
        ...params,
        container: element.current
      });
    }

    return () => {
      lottieInstance.current?.destroy();
    };

  }, []);

  return (
    <div className={styles.spinnerBackground}>
      <div className={`${styles.spinner} ${styles.responsiveSpinner}`} ref={element} />      <div>
        <div className={styles.parag1} >Retrieving your information</div>
        <div className={styles.parag2} >This should only take a moment</div>
      </div>
    </div>
  );
};
